module.exports = window["bonnet-webcomponent-@atc/react-device"];